
import React from "react";
import FeedbackMessage from "../FeedbackMessage";
import LoadingState from "./LoadingState";
import EmptyState from "./EmptyState";
import { FeedbackMessage as FeedbackMessageType } from "@/types/feedback";

interface FeedbackMessagesProps {
  messages: FeedbackMessageType[];
  isLoading: boolean;
  onReply: (parentId: string) => void;
  hasFilters: boolean;
}

const FeedbackMessages: React.FC<FeedbackMessagesProps> = ({
  messages,
  isLoading,
  onReply,
  hasFilters,
}) => {
  const organizeMessages = (messages: FeedbackMessageType[]) => {
    const topLevelMessages: FeedbackMessageType[] = [];
    const repliesMap: { [key: string]: FeedbackMessageType[] } = {};

    messages.forEach(message => {
      if (!message.parent_id) {
        topLevelMessages.push(message);
      } else {
        if (!repliesMap[message.parent_id]) {
          repliesMap[message.parent_id] = [];
        }
        repliesMap[message.parent_id].push(message);
      }
    });

    return { topLevelMessages, repliesMap };
  };

  if (isLoading) {
    return <LoadingState />;
  }

  if (messages.length === 0) {
    return <EmptyState hasFilters={hasFilters} />;
  }

  const { topLevelMessages, repliesMap } = organizeMessages(messages);

  return (
    <div>
      {topLevelMessages.map((message) => (
        <FeedbackMessage
          key={message.id}
          message={message}
          onReply={onReply}
          replies={repliesMap[message.id] || []}
        />
      ))}
    </div>
  );
};

export default FeedbackMessages;
